import { isEmail } from 'validator';
import { get } from 'lodash';

export const ACTIONS = {
  UPDATE_FIELD_VALUE: 'UPDATE_FIELD_VALUE',
  UPDATE_FIELD_ERRORS: 'UPDATE_FIELD_ERRORS',
  UPDATE_FORM_ERRORS: 'UPDATE_FORM_ERRORS',
  UPDATE_FORM_VALUES: 'UPDATE_FORM_VALUES',
}

const allFields = ['firstName', 'lastName', 'userName', 'email', 'password', 'confirmPassword', 'termsOfUse'];

export const accountSetupReducer = (state, action) => {
  switch (action.type) {
    case ACTIONS.UPDATE_FIELD_VALUE: {
      const { field, value } = action.payload;
      const updatedState = { ...state, [field]: { ...state[field], value } };
      return updatedState;
    }

    case ACTIONS.UPDATE_FIELD_ERRORS: {
      const { field, intl, regexPolicy } = action.payload;
      const value = state[field].value;
      const errors = validateField({
        state, field, value, intl, regexPolicy,
      });
      const updatedState = { ...state, [field]: { value, errors } };
      return updatedState;
    }

    case ACTIONS.UPDATE_FORM_ERRORS: {
      return action.payload.reduce((acc, curr) => {
        acc[curr.field] = { value: curr.value, errors: curr.errors }
        return acc;
      }, {});
    }

    case ACTIONS.UPDATE_FORM_VALUES: {
      const { data, intl, regexPolicy } = action.payload;
      const updatedState = { ...state };

      allFields.forEach(field => {
        if (data[field]) {
          updatedState[field].value = data[field]
        }
      });

      allFields.forEach(field => {
        if (data[field]) {
          updatedState[field].errors = validateField({
            field, value: data[field], state: updatedState, intl, regexPolicy,
          });
        }
      });

      return updatedState;
    }

    default: {
      throw Error('Unknown action: ' + action.type);
    }
  }
}

export const initializeAccountSetupState = () => {
  return {
    firstName: { value: '', errors: [] },
    lastName: { value: '', errors: [] },
    userName: { value: '', errors: [] },
    email: { value: '', errors: [] },
    password: { value: '', errors: [] },
    confirmPassword: { value: '', errors: [] },
    termsOfUse: { value: false, errors: [] },
  }
};

const validateField = ({ field, value, intl, state, regexPolicy }) => {
  const errors = [];

  if (['firstName', 'lastName', 'userName'].includes(field)) {
    if (value === '') {
      errors.push(intl.getI18nMessage('label.required.field'));
    } else if (value.length > 60) {
      errors.push(intl.getI18nMessage("label.user.details.textfields.helptext"));
    }
  }

  if (field === 'email' && !isEmail(state.email.value)) {
    errors.push(intl.getI18nMessage("label.user.account.setup.email.helptext"));
  }

  if (field === 'confirmPassword') {
    if (value === '') {
      errors.push(intl.getI18nMessage('label.required.field'));
    } else if (value !== state.password.value) {
      errors.push(intl.getI18nMessage("label.user.profile.password.match.error"));
    }
  }

  if (field === 'password') {
    const regex = get(regexPolicy, 'REGEX.value', '');
    if (value === '') {
      errors.push(intl.getI18nMessage('label.required.field'));
    } else if (!(new RegExp(regex).test(value))) {
      errors.push(intl.getI18nMessage("label.user.profile.password.format.error"));
    } else if (state.confirmPassword.value && (value !== state.confirmPassword.value)) {
      errors.push(intl.getI18nMessage("label.user.profile.password.match.error"));
      state.confirmPassword.errors.push(intl.getI18nMessage("label.user.profile.password.match.error"));
    } else {
      state.confirmPassword.errors = [];
    }
  }

  if (field === 'termsOfUse' && value !== true) {
    errors.push(intl.getI18nMessage("label.user.account.setup.termsOfUse.helptext.error"));
  }

  return errors;
}

export const validateFormInputs = ({ state, intl, regexPolicy }) => {
  let isFormValid = true;
  const validatedState = allFields.map(field => {
    const fieldErrors = validateField({
      field, value: state[field].value, intl, state, regexPolicy,
    });
    if (fieldErrors.length > 0) {
      isFormValid = false;
    }
    return { field, value: state[field].value, errors: fieldErrors }
  })
  return { validatedState, isFormValid };
}